import React from 'react';
import ReactDOM from 'react-dom/client';
import {ToastProvider} from 'use-toast-mui';
import {AuthProvider} from "./providers/AuthProvider";
import {BrowserRouter as Router} from "react-router-dom";
import { App } from './components/App';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <Router>
            <ToastProvider>
                <AuthProvider>
                    <App/>
                </AuthProvider>
            </ToastProvider>
        </Router>
    </React.StrictMode>
);
